module.exports = __webpack_public_path__ + "img/daedal-logo-light.5d92f727.png";